"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _createStyles = require("../styles/createStyles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LONG_DURATION_MINUTES = 120;
const MEDIUM_DURATION_MINUTES = 45;
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    colors
  } = theme.busbud;
  return {
    root: {
      color: colors.component.stopTime.short
    },
    longDuration: {
      color: colors.component.stopTime.long
    },
    mediumDuration: {
      color: colors.component.stopTime.medium
    }
  };
});
/**
 * The StopTime component can be used to display a duration with a color hint based on the duration value.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-stoptime--page)
 */
const StopTime = props => {
  const {
    durationMinutes,
    classes: classesOverrides,
    children
  } = props;
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  return /*#__PURE__*/React.createElement(_Label.default, {
    size: "sm",
    fontWeight: "bold",
    className: cx(classes.root, {
      [classes.longDuration]: durationMinutes >= LONG_DURATION_MINUTES,
      [classes.mediumDuration]: durationMinutes < LONG_DURATION_MINUTES && durationMinutes >= MEDIUM_DURATION_MINUTES
    })
  }, children);
};
var _default = exports.default = StopTime;